import React from "react";
import { cls } from "cls";
import handleSectionAlignment from "../Utilities/handleSectionAlignment";
import { AlignmentType, HeroModel } from "../Models/PageCreatorPage";
import ButtonLink from "./ButtonLink";
import { getSanitizedHtml } from "../Utilities/htmlInputUtility";
import ZestVideoPlayer from "~/common/videoPlayer/ZestVideoPlayer";

const LeadGenHero = ({
  backgroundColor,
  backgroundImageUrl,
  useImageForBackground,
  alignmentType,
  logoUrl,
  logoAltText,
  headerTextColor,
  bodyTextColor,
  header,
  bodyText,
  buttonUrl,
  buttonUrlType,
  buttonText,
  buttonBackgroundColor,
  buttonTextColor,
  hasImage,
  imageUrl,
  imageAltText,
  hasBottomPadding,
  hasTopPadding,
  video,
  hasButton,
}: HeroModel): JSX.Element => {
  return (
    <div
      id="hero-wrapper"
      className={cls(
        "px-6",
        "md:px-12",
        hasBottomPadding ? ["pb-12", "md:pb-24"] : "pb-0",
        hasTopPadding ? ["pt-12", "md:pt-24"] : "pt-0",
      )}
      style={{
        background: useImageForBackground
          ? `url("${backgroundImageUrl}") no-repeat center center`
          : backgroundColor,
        backgroundSize: "cover",
      }}
    >
      <div
        id="hero-content-wrapper"
        className={cls(
          handleSectionAlignment(hasImage, alignmentType),
          "flex",
          "flex-col",
          "items-center",
          "space-y-12",
          "lg:flex",
          "lg:flex-row",
          "lg:space-y-0",
          "lg:gap-12",
          "max-w-6xl",
          "mx-auto",
        )}
      >
        <div
          id="hero-content"
          className={`${cls(
            "flex",
            "flex-col",
            "h-fit",
            "items-center",
            alignmentType === AlignmentType.Left
              ? "lg:items-start"
              : "lg:items-center",
            "w-auto",
          )} ${hasImage ? "lg:w-[48%]" : ""}`}
        >
          <img
            id="logo-img"
            src={logoUrl}
            alt={logoAltText}
            className={cls("h-fit", "w-auto")}
          />
          {!!header && (
            <h1
              className={`${cls(
                "flex-wrap",
                "text-3xl",
                "text-center",
                "font-bold",
                "m-0",
                "mt-6",
                alignmentType === AlignmentType.Left
                  ? "lg:text-left"
                  : "lg:text-center",
                "md:text-4xl",
                "lg:text-5xl",
              )} [text-wrap:balance]`}
              style={{ color: headerTextColor, textShadow: "none" }}
            >
              {header}
            </h1>
          )}
          {!!bodyText && (
            <p
              className={`${cls(
                "m-0",
                "mt-1",
                "lt:mt-2",
                "text-base",
                "flex-wrap",
                "text-center",
                "leading-tight",
                alignmentType === AlignmentType.Left
                  ? "lg:text-left"
                  : "lg:text-center",
              )} [text-wrap:balance]`}
              style={{ color: bodyTextColor }}
            >
              {getSanitizedHtml(bodyText)}
            </p>
          )}
          {!!hasButton && (
            <ButtonLink
              backgroundColor={buttonBackgroundColor}
              textColor={buttonTextColor}
              buttonUrl={buttonUrl}
              buttonUrlType={buttonUrlType}
              text={buttonText}
              buttonExtraClassNames="mt-6"
            />
          )}
        </div>
        {hasImage && (
          <img
            id="hero-img"
            src={imageUrl}
            alt={imageAltText}
            className={`${cls(
              "w-full",
              "max-w-lg",
              "mx-auto",
              "lg:max-w-full",
            )}  lg:w-[48%]`}
          />
        )}
        {!!video && (
          <ZestVideoPlayer
            posterImage={video.poster}
            sources={video.sources}
            closedCaptionsrc={video.closedCaptionFile}
            currentIndex={0}
            selected={0}
            playsInline
          />
        )}
      </div>
    </div>
  );
};

export default LeadGenHero;
